const GET_CURRENT_STAGE = 'GET_CURRENT_STAGE' as const;
const BUY_TOKEN = 'BUY_TOKEN' as const;

export const crowdSaleActionTypes = {
  GET_CURRENT_STAGE,
  BUY_TOKEN,
};
